import { ref, push } from 'firebase/database';
import { auth, database } from '../firebaseConfig';

// Welcome invite for a user. Admin only. ONE path now: the server puts never-signed-in accounts on the
// temporary password `welcome` (+ mustChangePassword) and sends the branded SendGrid email.
// The old Firebase reset-email fallback is gone (its 1-hour single-use links are what locked agents out).
// If SendGrid can't send, nothing is emailed; the admin gets the same instructions to pass on by text.
// Returns { ok, via: 'sendgrid' | 'manual' | null, reason, instructions }.
export const WELCOME_INSTRUCTIONS = (email) => `Your Resi login email: ${email}. Your username: ${email} (this is the email you'll use to log in to resisystem.com). Go to https://resisystem.com/login, sign in with ${email} and the temporary password welcome (all lowercase), then set your own password.`;

export const sendWelcomeInvite = async (uid, email) => {
  let reason = '';
  try {
    const idToken = await auth.currentUser.getIdToken();
    const res = await fetch('/api/welcome-email', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` }, body: JSON.stringify({ uid }) });
    const data = await res.json().catch(() => ({}));
    if (res.ok && data.sent) return { ok: true, via: 'sendgrid' };
    reason = data.reason || data.error || `HTTP ${res.status}`;
    if (reason === 'already_signed_in') return { ok: false, via: null, reason };
  } catch (e) { reason = 'server_unreachable'; }
  const me = auth.currentUser;
  push(ref(database, 'crm/messageLog'), {
    channel: 'email', type: 'welcome', to: [email], from: 'not sent', fromName: 'Welcome email (not sent)', replyTo: [], subject: 'Welcome to Resi: sign in and set your password',
    agentUid: me ? me.uid : null, agentName: (me && (me.displayName || me.email)) || '', newUserUid: uid || null,
    status: 'failed', error: reason || null, fallbackReason: reason || null, sentAt: new Date().toISOString(),
  }).catch(() => {});
  return { ok: false, via: 'manual', reason, instructions: WELCOME_INSTRUCTIONS(email) };
};
